const kb_getraenke = [
	{
		id: 1,
		title: "Softdrinks 0,33l",
		description: "Cola, Sprite, Spezi, Fanta, Apfelschorle",
		price: "3.00",
	},
	{
		id: 1,
		title: "Almdudler 0,35l",
		description: "Kräuterlimonade",
		price: "3.50",
	},
	{
		id: 1,
		title: "Bauer Schorle 0,33l",
		description: "Rhabarber / Maracuja",
		price: "3.50",
	},

	{
		id: 4,
		title: "Eistee 0,33l / Pfirsich",
		price: "3.50",
	},
	{
		id: 5,
		title: "Wasser 0,25l ",
		description: "still oder spritzig",
		price: "2.50",
	},
	{
		id: 6,
		title: "Wasser 0,5l",
		description: "still oder spritzig",
		price: "3.70",
	},
	{
		id: 7,
		title: "Bier 0,33l",
		description: "Schlappeseppel Spezial",
		price: "3.00",
	},
	{
		id: 8,
		title: "Natur-Radler 0,33l / Faust",
		price: "2.90",
	},
	{
		id: 9,
		title: "Hefe 0,5l / Faust",
		price: "3.30",
	},
	{
		id: 2,
		title: "Alkoholfreies Pils 0,33l / Faust",
		price: "2.90",
	},
	{
		id: 3,
		title: "Alkoholfreies Hefe 0,5l / Faust",
		price: "3.30",
	},
	{
		id: 10,
		title: "Secco 0,1l",
		price: "4.20",
	},
	{
		id: 11,
		title: "Secco-Mix 0,2l",
		description: "(Udoh, Aperol, HuGo, Limoncello, Cassis, Bratapfellikör)",
		price: "6.50",
	},

	{
		id: 12,
		title: "Bacchus 0,2l / halbtrocken",
		price: "4.50",
	},
	{
		id: 13,
		title: "Müller Thurgau 0,2l / trocken",
		price: "4.50",
	},
	{
		id: 14,
		title: "Spätburgunder 0,2l / trocken",
		price: "4.90",
	},
];

export default kb_getraenke;
